const DEFAULT_TIMEOUT_MS = 1800000; // 30 minutes
const EVENTS: (keyof WindowEventMap)[] = ['mousemove', 'keydown', 'touchstart', 'scroll'];

let timerId: ReturnType<typeof setTimeout> | null = null;
let boundReset: (() => void) | null = null;

export function startIdleTimer(
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
  onTimeout: () => void
): void {
  stopIdleTimer();

  const reset = () => {
    if (timerId !== null) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(onTimeout, timeoutMs);
  };

  boundReset = reset;

  EVENTS.forEach((event) => window.addEventListener(event, reset, { passive: true }));

  // Start the initial timer
  timerId = setTimeout(onTimeout, timeoutMs);
}

export function stopIdleTimer(): void {
  if (timerId !== null) {
    clearTimeout(timerId);
    timerId = null;
  }

  if (boundReset) {
    EVENTS.forEach((event) => window.removeEventListener(event, boundReset!));
    boundReset = null;
  }
}
